export const PlaceMent = ['top', 'bottom'];
